import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import AboutUs from '@/components/AboutUs'
import Login from '@/components/Login'
import ForgotPassword from '@/components/ForgotPassword'
import RedefinePassword from '@/components/RedefinePassword'
import Signup from '@/components/Signup'
import SignupOng from '@/components/SignupOng'
import Dashboard from '@/components/Dashboard'
import Settings from '@/components/Settings'
import Profile from '@/components/Profile'
import Notifications from '@/components/Notifications'
import Projects from '@/components/Projects'
import ManageProject from '@/components/ManageProject'
import Project from '@/components/Project'
import Donation from '@/components/Donation'
import DonationMethod from '@/components/DonationMethod'
import DonationFinish from '@/components/DonationFinish'
import CreateProject from '@/components/CreateProject'
import CreateCampaign from '@/components/CreateCampaign'
import MyDonations from '@/components/MyDonations'
import MyProjects from '@/components/MyProjects'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'
import MainDescontos from '@/components/descontosdobem/Main'
import MainDescontosDescontos from '@/components/descontosdobem/MainDescontos'
import MainDescontosProdutos from '@/components/descontosdobem/MainProdutos'
import Store from '@/components/descontosdobem/Store'
import AniversarioHome from '@/components/aniversariodobem/AniversarioHome'
import AniversarioForm from '@/components/aniversariodobem/AniversarioForm'
import AniversarioInvite from '@/components/aniversariodobem/AniversarioInvite'
import FirstAccess from '@/components/FirstAccess';
import auth from '../services/auth';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/privacy-policy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms-and-conditions',
      name: 'Terms',
      component: Terms
    },
    // {
    //   path: '/aniversariodobem',
    //   name: 'AniversarioHome',
    //   component: AniversarioHome
    // },
    // {
    //   path: '/aniversariodobem/create',
    //   name: 'AniversarioForm',
    //   component: AniversarioForm
    // },
    // {
    //   path: '/aniversariodobem/:invite',
    //   name: 'AniversarioInvite',
    //   component: AniversarioInvite
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if(auth.isAuth()){
          next('/dashboard');
        }else{
          next()
        }
      }
    },
    {
      path: '/login-and-redirect/:ProjectSlug',
      name: 'LoginAndRedirect',
      component: Login,
      beforeEnter: (to, from, next) => {
        if(auth.isAuth()){
          next('/dashboard');
        }else{
          next()
        }
      }
    },
    {
      path: '/confirm-email/:token',
      name: 'ConfirmEmail',
      component: Login,
      beforeEnter: (to, from, next) => {
        if(auth.isAuth()){
          next('/dashboard/confirm-email/' + to.params.token);
        }else{
          next()
        }
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      beforeEnter: (to, from, next) => {
        if(auth.isAuth()){
          next('/dashboard');
        }else{
          next()
        }
      }
    },
    {
      path: '/redefine-password/:token',
      name: 'RedefinePassword',
      component: RedefinePassword,
      beforeEnter: (to, from, next) => {
        if(auth.isAuth()){
          next('/dashboard');
        }else{
          next()
        }
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: (to, from, next) => {
        if(auth.isAuth()){
          next('/dashboard');
        }else{
          next()
        }
      }
    },
    {
      path: '/signup-ong',
      name: 'SignupOng',
      component: SignupOng,
      beforeEnter: (to, from, next) => {
        if(auth.isAuth()){
          next('/dashboard');
        }else{
          next()
        }
      }
    },
    {
      path: '/first-access',
      name: 'FirstAccess',
      component: FirstAccess,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: Notifications,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/create-campaign',
      name: 'CreateCampaign',
      component: CreateCampaign,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/signup');
        }else{
          next()
        }
      }
    },
    {
      path: '/create-project/:type?',
      name: 'CreateProject',
      component: CreateProject,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/signup');
        }else{
          next()
        }
      }
    },
    {
      path: '/project/manage/:slug',
      name: 'ManageProject',
      component: ManageProject,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/dashboard/confirm-email/:token',
      name: 'DashboardConfirmEmail',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/profile/my-donations',
      name: 'MyDonations',
      component: MyDonations,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/profile/my-projects',
      name: 'MyProjects',
      component: MyProjects,
      beforeEnter: (to, from, next) => {
        if(!auth.isAuth()){
          next('/login');
        }else{
          next()
        }
      }
    },
    {
      path: '/projects/:slug?',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/project/:slug',
      name: 'Project',
      component: Project
    },
    {
      path: '/project/donation/:slug',
      name: 'Donation',
      component: Donation
    },
    {
      path: '/project/donate/:slug',
      name: 'Donate',
      component: Donation
    },
    {
      path: '/project/donation/method/:DonationId',
      name: 'DonationMethod',
      component: DonationMethod
    },
    {
      path: '/project/donation/finish/:DonationId',
      name: 'DonationFinish',
      component: DonationFinish
    },
    {
      path: '/descontosdobem',
      name: 'MainDescontos',
      component: MainDescontos
    },
    {
      path: '/d/:slug',
      name: 'MainDescontosProject',
      component: MainDescontosDescontos
    },
    {
      path: '/descontosdobem/descontos',
      name: 'MainDescontosDescontos',
      component: MainDescontosDescontos
    },
    {
      path: '/descontosdobem/produtos',
      name: 'MainDescontosProdutos',
      component: MainDescontosProdutos
    },
    {
      path: '/descontosdobem/store/:storeSlug/:slug?',
      name: 'Store',
      component: Store
    },
    {
      path: '/:slug?',
      name: 'ProjectWithSlug',
      component: Home,
      beforeEnter: (to, from, next) => {
        if(to.params.slug){
          next('/project/' + to.params.slug);
        }else{
          next()
        }
      }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if(to.name != "Projects"){
      return { x: 0, y: 0 }
    }else if(from.name == "Project" && to.name == "Projects"){
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 5000)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js